import { render, staticRenderFns } from "./WebsiteNewsContent.vue?vue&type=template&id=786be182&"
import script from "./WebsiteNewsContent.vue?vue&type=script&lang=js&"
export * from "./WebsiteNewsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports